export enum ErrorCode {
    apiRequest = 'EAPIREQUEST',
    axios = 'EAXIOSERROR',
    notFound = 'ENOTFOUND',
}
